import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';

import { User, UserId } from './user.model';
import { UserRepository } from './user.repository';


@Injectable()
export class UserResolve implements Resolve<User> {

  constructor(
    private router: Router,
    private userRepository: UserRepository
  ) { }

  resolve(route: ActivatedRouteSnapshot): Promise<User> {
    const userId: UserId = route.params['userId'];

    if (userId) {
      return this.userRepository.get(userId)
        .toPromise();
    }

    return null;
  }
}



// WEBPACK FOOTER //
// /dist/src/app/user/user.resolve.ts